import Icon from 'helpers/svg-icon';

import {
  grey60,
  grey70,
  white,
  error,
  mainTextColor,
} from 'constants/variables';
import { iconGrey71, iconGrey31 } from 'constants/shared_icon_exports';

const CrossIcon = ({
  fillColor = grey70,
  width = 55,
  height = 55,
  title,
  ...rest
}) => (
  <Icon
    viewBox="0 0 54.6 54.6"
    x="0px"
    y="0px"
    width={width}
    height={height}
    title={title}
    {...rest}>
    <polygon
      style={{ fill: fillColor }}
      points="54.6,9.4 45.3,0 27.3,18 9.4,0 0,9.4 18,27.3 0,45.3 9.4,54.6 27.3,36.7 45.3,54.6 54.6,45.3
  36.7,27.3 "
    />
  </Icon>
);

const PlusIcon = ({
  fillColor = white,
  width = 20,
  height = 20,
  title,
  ...rest
}) => (
  <Icon
    height={height}
    width={width}
    viewBox="0 0 20 20"
    title={title}
    {...rest}>
    <path
      d="m8.261 0v8.261h-8.261v3.479h8.261v8.26h3.479v-8.26h8.26v-3.479h-8.26v-8.261z"
      fill={fillColor}
    />
  </Icon>
);

const MinusIcon = ({ fillColor, width = 12, height = 12, title, ...rest }) => (
  <Icon
    viewBox="0 0 12 12"
    width={width}
    height={height}
    title={title}
    {...rest}>
    <g>
      <path fill={fillColor} d="M12,6.86H0v-1.71H12v1.71Z" />
    </g>
  </Icon>
);

const UploadIcon = ({
  fillColor = grey70,
  width = 18.616,
  height = 23.233,
  ...rest
}) => (
  <Icon viewBox="0 0 18 23" width={width} height={height} {...rest}>
    <path
      fill={fillColor}
      d="M234.83-.829V-7H222.4V16.233h18.616V-.829Zm-3.122.581,4.2,4.182L234.83,5.125,232.565,2.86V8.973h-1.713v-6.1L228.629,5.1l-1.118-1.133Zm5.14,12.953H226.567V11.049h10.281Z"
      transform="translate(-222.4 7)"
    />
    <path
      fill={fillColor}
      d="M231.85-7v4.888h4.886Z"
      transform="translate(-218.128 7)"
    />
  </Icon>
);

const DownloadIcon = ({
  fillColor = error,
  width = 10,
  height = 12,
  ...rest
}) => (
  <Icon viewBox="0 0 10 12" width={width} height={height} {...rest}>
    <path
      fill={fillColor}
      d="M17.152,8.637H14.395V4.5H10.258V8.637H7.5l4.826,4.826ZM7.5,14.842v1.379h9.652V14.842Z"
      transform="translate(-7.5 -4.5)"
    />
  </Icon>
);

const CloseWhite = ({
  fillColor = white,
  width = 14,
  height = 14,
  ...rest
}) => (
  <Icon height={height} width={width} viewBox="0 0 14.16 14.16" {...rest}>
    <path
      d="M2.1,14.16l5-5,5,5,2.1-2.1-5-5,5-5L12.06,0l-5,5-5-5L0,2.09l5,5-5,5Z"
      fill={fillColor}
    />
  </Icon>
);

const CloseXmark = ({
  width = 38,
  height = 38,
  backgroundFllColor = white,
  mainFillColor = mainTextColor,
  strokeColor = mainTextColor,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 38 38" {...rest}>
    <g transform="translate(-1162 -272)">
      <circle
        cx="19"
        cy="19"
        r="19"
        transform="translate(1162 272)"
        fill={backgroundFllColor}
      />
      <path
        d="M13.6,10.4V0H10.4V10.4H0v3.2H10.4V24h3.2V13.6H24V10.4Z"
        transform="translate(1181 274.48) rotate(45)"
        fill={mainFillColor}
        stroke={strokeColor}
        strokeWidth="1"
      />
    </g>
  </Icon>
);

const SearchIcon = ({
  fillColor = iconGrey31,
  width = 15,
  height = 15,
  title,
  ...rest
}) => (
  <Icon
    height={height}
    width={width}
    viewBox="0 0 15 15.188"
    title={title}
    {...rest}>
    <path
      d="M15,13.2,11.391,9.352A6.251,6.251,0,0,0,12.3,6.141a6.152,6.152,0,0,0-12.3,0,6.138,6.138,0,0,0,9.4,5.2l3.609,3.844ZM2.109,6.141a4.031,4.031,0,1,1,4.031,4.031A4.031,4.031,0,0,1,2.109,6.141Z"
      fill={fillColor}
    />
  </Icon>
);

const CircleXmark = ({
  circleFillColor = iconGrey71,
  xmarkFillColor = white,
  width = 38,
  height = 38,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 20 20" {...rest}>
    <g transform="translate(-800 -1691)">
      <circle
        cx="10"
        cy="10"
        r="10"
        transform="translate(800 1691)"
        fill={circleFillColor}
      />
      <g transform="translate(809.928 1693.858) rotate(45)">
        <rect
          id="Rectangle_13980"
          data-name="Rectangle 13980"
          width="2"
          height="10"
          transform="translate(4)"
          fill={xmarkFillColor}
        />
        <rect
          width="2"
          height="10"
          transform="translate(10 4) rotate(90)"
          fill={xmarkFillColor}
        />
      </g>
    </g>
  </Icon>
);

const ArchiveIcon = ({
  width = 17.54,
  height = 16,
  fillColor = grey60,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 17.54 16" {...rest}>
    <path
      d="M8.039,5.706H9.5v4.488L11.6,8.274l.975.893-3.8,3.484-3.8-3.484.976-.893,2.094,1.921ZM2.752,1.262H14.763l.877,1.027H1.876ZM2.156,0,.073,2.412,0,16H17.54L17.468,2.412,15.372,0Z"
      fill={fillColor}
    />
  </Icon>
);

const UnarchiveIcon = ({
  width = 17.54,
  height = 16,
  fillColor = grey60,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 17.54 16" {...rest}>
    <path
      d="M4.969,9.19l3.8-3.484,3.8,3.484-.975.892L9.5,8.163v4.488H8.039V8.163l-2.094,1.92ZM2.752,1.262H14.763l.877,1.027H1.876ZM2.156,0,.073,2.412,0,16H17.54L17.468,2.412,15.372,0Z"
      fill={fillColor}
    />
  </Icon>
);

const DeleteIcon = ({
  width = 14.222,
  height = 16,
  fillColor = grey60,
  ...rest
}) => (
  <Icon width={width} height={height} viewBox="0 0 14.222 16" {...rest}>
    <path
      d="M4.6,3.889H5.934v8.867H4.6Zm3.689,0H9.622v8.867H8.289ZM4.178,0V.667H0V2H.911V16h12.4V2h.911V.667H10.044V0Z"
      fill={fillColor}
    />
  </Icon>
);

export {
  UploadIcon,
  DownloadIcon,
  CrossIcon,
  PlusIcon,
  MinusIcon,
  CloseWhite,
  SearchIcon,
  CloseXmark,
  CircleXmark,
  ArchiveIcon,
  UnarchiveIcon,
  DeleteIcon,
};
